/**
 * Class definition for `clover map point` element
 *
 * @class CloverMapPoint
 * @extends {HTMLElement}
 */
class CloverMapPoint extends HTMLElement {
	constructor() {
		self = super(self);
		return self;
	}

	/**
	 * Tag name of element
	 *
	 * @readonly
	 * @static
	 */
	static get is() {
		return 'clover-map-point';
	}

	/**
	 * Getter for `lat` attribute
	 */
	get lat() {
		return this.getAttribute('lat');
	}

	/**
	 * Setter for `lat` attribute
	 */
	set lat(value) {
		if (Number(value)) {
			this.setAttribute('lat', '');
		} else {
			this.removeAttribute('lat');
		}
	}

	/**
	 * Getter for `lng` attribute
	 */
	get lng() {
		return this.getAttribute('lng');
	}

	/**
	 * Setter for `lng` attribute
	 */
	set lng(value) {
		if (Number(value)) {
			this.setAttribute('lng', '');
		} else {
			this.removeAttribute('lng');
		}
	}


	/**
	 * Lifecycle event when element is attached to DOM
	 */
	connectedCallback() {
		if (!this.lng || !this.lat) {
			console.warn('Missing lat or long value, removing point');
			return;
		}
	}
}

customElements.define(CloverMapPoint.is, CloverMapPoint);
